import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type ContactUsIconProps = CommonSvgProps

const ContactUsIcon: React.FC<ContactUsIconProps> = React.forwardRef<
  SVGSVGElement,
  ContactUsIconProps
>((props, ref) => (
  <Svg viewBox="0 0 33 33" {...props} ref={ref} color="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.698 6.469c0-.408.33-.738.739-.738h24.468c.407 0 .738.33.738.738v15.906c0 .408-.33.739-.738.739H15.784L9.758 26.92a.739.739 0 0 1-1.133-.624v-3.183H4.436a.738.738 0 0 1-.738-.739V6.47Zm1.477.738v14.43h4.189c.407 0 .738.33.738.738v2.582l5.074-3.206a.738.738 0 0 1 .394-.114h12.596V7.207H5.175Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.655 12.797c0-.233.189-.422.422-.422h3.375c.233 0 .422.189.422.422v3.375a.422.422 0 0 1-.422.422H9.077a.422.422 0 0 1-.422-.422v-3.375Z"
      fill="#15539F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.561 12.797c0-.233.19-.422.422-.422h3.375c.233 0 .422.189.422.422v3.375a.422.422 0 0 1-.422.422h-3.375a.422.422 0 0 1-.422-.422v-3.375Z"
      fill="#53A2D9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.467 12.797c0-.233.19-.422.422-.422h3.375c.233 0 .422.189.422.422v3.375a.422.422 0 0 1-.422.422h-3.375a.422.422 0 0 1-.422-.422v-3.375Z"
      fill="#7BB835"
    />
  </Svg>
))

ContactUsIcon.propTypes = commonPropTypes
ContactUsIcon.defaultProps = commonDefaultProps

export default ContactUsIcon
